import { IKPIIndicator } from 'pages/PageKPIIndicatorList/interfaces';

export enum EKPITypes {
  REAL_ESTATE = 'real_estate',
  HOUSE = 'house',
  DEPOSIT = 'deposit',
}

export enum EKPIUnits {
  PERCENT = 'percent',
  COUNT = 'count',
}

export interface IKPIType {
  kpiTypeId?: number;
  kpiSubType?: EKPITypes | String;
  kpiIndicator?: IKPIIndicator | null;
  kpiIndicatorId?: number;
  kpiIndicatorName?: string;
  limits: number;
  intent: number;
  challenge: number;
  specificGravity: number;
  unit: EKPIUnits | String;
  positions: IPosition[] | number[];
}

export interface IPosition {
  positionId: number;
  positionName: string;
}
